import { Injectable } from '@angular/core';
import { Tag } from './tag'
import { Topic } from './topic'
import { DbRecord } from './db-record'
import { DbRecordService } from './db-record.service'
import { PatentService } from './patent.service'
import { RuntimeService } from './runtime.service'
//import { TagService } from './tag.service'

@Injectable()
export class FilterService {
  searchFilter: RegExp
  sourceFilter: RegExp
  recordIdFilter: string
  tagFilters = new Set<Tag>()
  tagExcludeFilters = new Set<Tag>()
  topicFilter: Topic
  rts: RuntimeService
  dbrs: DbRecordService
  orTagOn = false

  constructor(
    private ps: PatentService
  ) { }

  run(ls: DbRecord[]) {
    if (this.recordIdFilter) {
      let record = this.dbrs.getDbRecord(this.recordIdFilter)
      return record ? [record] : []
    }
    let noTagsOnly = this.tagFilters.has(this.rts.noTags)
    let withTagsOnly = this.tagExcludeFilters.has(this.rts.noTags)
    if (noTagsOnly || withTagsOnly) {
      let considerSet = new Set<string>()
      let s = new Set<string>()
      this.rts.currentProject.tagsMap.forEach(t => {
        if (t.title.indexOf('consider') > -1)
          t.taggedItems.forEach(v => considerSet.add(v))
        else
          t.taggedItems.forEach(v => s.add(v))
      })

      if (noTagsOnly)
        ls = ls.filter((x) => !s.has(x.id) || considerSet.has(x.id))
      else if (withTagsOnly)
        ls = ls.filter((x) => s.has(x.id))
    }
    else if (this.tagFilters.size)
      ls = ls.filter((x) => x.hasTags(this.tagFilters, this.orTagOn))

    if (this.topicFilter) {
      let s = this.rts.currentProject.topicDbRecordsMap
        .get(this.topicFilter.id) || new Set<string>()
      ls = ls.filter((x) => s.has(x.id))
    }


    if (this.tagExcludeFilters.size)
      ls = ls.filter((x) => x.excludeTags(this.tagExcludeFilters))
    if (this.searchFilter)
      ls = ls.filter((x) => x.regexpHit(this.searchFilter))
    if (this.sourceFilter)
      ls = ls.filter((x) => x.sourceHit(this.sourceFilter))
    if (this.rts.currentProject.hasPatents)
      ls = this.ps.filter(ls)
    return ls
  }

  highlightSearchHits(txt: string) {
    if (!this.searchFilter || !txt)
      return txt
    return txt.replace(this.searchFilter, '<span class="searchHit">$&</span>')
  }

  setTagFilter(tag: Tag) {
    if (!this.tagFilters.delete(tag)) {
      this.tagFilters.add(tag)
      this.tagExcludeFilters.delete(tag)
    }
  }

  isSelectedTag(tag: Tag) {
    return this.tagFilters.has(tag)
  }

  setExcludeTagFilter(tag: Tag) {
    if (!this.tagExcludeFilters.delete(tag)) {
      this.tagExcludeFilters.add(tag)
      this.tagFilters.delete(tag)
    }
  }

  isExcludedTag(tag: Tag) {
    return this.tagExcludeFilters.has(tag)
  }

  setTopicFilter(topic: Topic) {
    if (this.topicFilter == topic)
      this.topicFilter = null
    else
      this.topicFilter = topic
  }

  isSelectedTopic(topic: Topic) {
    return this.topicFilter == topic
  }

  clear() {
    this.searchFilter = null
    this.tagFilters.clear()
  }

}



// WEBPACK FOOTER //
// ./src/app/filter.service.ts